import React from "react";
import { Helmet } from "react-helmet";

const Head = () => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>Saharawinds | Logistics Excellence</title>
      <meta
        name="description"
        content="Saharawinds Ltd provides comprehensive logistics solutions, including air freight, sea freight, customs clearance, cold chain logistics, and inland transport."
      />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta charSet="UTF-8" />

      {/* Open Graph / Social Media Metadata */}
      <meta property="og:title" content="Saharawinds | Logistics Solutions" />
      <meta
        property="og:description"
        content="Explore seamless global logistics with Saharawinds. Specializing in air, sea, and road transport, cold chain logistics, and more."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.saharawinds.com" />
      <meta
        property="og:image"
        content="https://www.saharawinds.com/ship-home.png"
      />

      {/* Favicon */}
      <link rel="icon" href="/favicon.ico" />

      {/* External Stylesheets */}
      {/* <link
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
        rel="stylesheet"
      />
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
        rel="stylesheet"
      /> */}

      {/* Additional Metadata */}
      <meta name="author" content="Saharawinds Ltd" />
      <meta
        name="keywords"
        content="Logistics, Freight, Transport, Kenya, Customs, Air Freight, Sea Freight, Warehousing"
      />

      {/* Scripts (if needed) */}
      {/* <script
        src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/js/bootstrap.min.js"
        defer
      ></script> */}
    </Helmet>
  );
};

export default Head;
